import { useEffect, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
import { NavLink } from "react-router-dom";
/**
 * Components
 */
import TopActionBar from "../../components/TopActionBar";
import FilterTable from "../../components/Filter/FilterTable";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Details from "../../components/Modals/Lens/Details";
import Delete from "../../components/Modals/Delete";
import Update from "../../components/Modals/Lens/Update";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenuTable";
import TitleMenu from "../../components/Title/TitleMenu";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
//Hooks
import useLoading from "../../hooks/useLoading";
import { useCheckbox } from "../../hooks/useCheckbox";
import { useMultipleModal } from "../../hooks/useMultipleModal";
//Interface
import { ILens } from "Interfaces/ILens";
import { IPage } from "Interfaces/IPage";
//Icons
import { Trash, List, PencilSimple } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";

export default function Lens() {
  const [data, setData] = useState<ILens[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const [selectAll, setSelectAll] = useState(false);

  // Para um array de objetos
  const [tags, setTags] = useState<Array<{
    barcode: string;
    code: string;
    price: string;
  }>>([]);

  const [headerTable, setHeaderTable] = useState([
    { name: '#', filter: false },
    { name: 'Nome', filter: false },
    { name: 'Índice', filter: true, data: [], url: 'indices.index', api: 'indice', activeFilter: false },
    { name: 'Tipo', filter: true, data: [], url: 'type_lens.type_lens', api: 'tipo', activeFilter: false },
    { name: 'Antirreflexo', filter: true, data: [], url: 'treatment.treatment', api: 'tratamento', activeFilter: false },
    { name: 'Fotossen.', filter: true, data: [], url: 'sensitivity.sensitivity', api: 'fotossensibilidade', activeFilter: false },
    { name: 'Esferico', filter: false, data: [], url: 'spherical', api: 'esferico' },
    { name: 'Cilindro', filter: false, data: [], url: 'cylindrical', api: 'cilindro' },
    { name: 'Adição', filter: false, data: [], url: 'addition', api: 'adicao' },
    { name: 'Ações', filter: false },
  ]);

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const titleListPopMenu = [
    "Lente",
    "Altura",
    "Antirreflexo",
    "Diâmetro",
    "Índice",
    "Laboratório",
    "Sensibilidade",
    "Surfaçagem",
    "Tipo de Lente",
  ];
  const titlePopButtton = [
    "lens",
    "height",
    "anti-glare",
    "diameter",
    "index",
    "laboratory",
    "sensitivity",
    "surfacing",
    "type-lens",
  ];

  const [filters, setFilters] = useState({
    indice: "",
    tipo: "",
    tratamento: "",
    fotossensibilidade: "",
  });

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const extractFilterData = (apiData: ILens[]) => {
    const updatedHeaderTable = headerTable.map(header => {
      if (header.filter && header.url) {
        // Verifica se a URL contém um ponto (indicando propriedade aninhada)
        if (header.url.includes('.')) {
          const [parentProp, childProp] = header.url.split('.');

          // Extrai valores únicos das propriedades aninhadas
          const uniqueValues = Array.from(
            new Set(
              apiData
                .map(item => item[parentProp as keyof ILens])
                .filter(obj => obj !== null && obj !== undefined)
                // Aqui precisamos fazer um cast para acessar a propriedade dinâmica
                .map(obj => (obj as any)[childProp])
            )
          );

          const filteredValues = uniqueValues.filter(
            (value): value is string | number => value !== null && value !== undefined
          );

          return { ...header, data: filteredValues };
        } else {
          // Para propriedades diretas (não aninhadas)
          const uniqueValues = Array.from(
            new Set(apiData.map(item => item[header.url as keyof ILens]))
          );

          const filteredValues = uniqueValues.filter(
            (value): value is string | number => value !== null && value !== undefined
          );

          return { ...header, data: filteredValues };
        }
      }
      return header;
    });

    return updatedHeaderTable;
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/lens?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm.trim()) {
        url += `&search=${searchTerm}`;
      }

      // Adicionar filtros à URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${value}`;
        }
      });

      const response = await axiosInstance.get(url);
      const apiData = response.data.data;
      console.log('url: ', url);
      console.log('response: ', response);

      // Extrair os dados para os filtros
      const updatedHeaderTable = extractFilterData(apiData);

      // Atualiza o state com os novos dados de cabeçalho
      setHeaderTable(updatedHeaderTable as typeof headerTable);

      setData(response.data.data);
      setCurrentPage(response.data);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm, filters]);

  const handleSelectAll = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);

      // Adiciona todos os itens às tags se ainda não estiverem presentes
      setTags(prevTags => {
        // Criar um mapa dos códigos existentes para evitar duplicatas
        const existingCodes = new Set(prevTags.map(tag => tag.code));

        // Filtrar apenas os itens que ainda não existem nas tags
        const newItems = data.filter(item => !existingCodes.has(item.barcode))
          .map(item => ({
            barcode: item.barcode || '',
            code: item.name_lens || '',
            price: item.price || ''
          }));

        // Retorne a combinação do array anterior com os novos itens
        return [...prevTags, ...newItems];
      });

    } else {
      CleanSelectIds();
      setTags([]);
    }
  };

  const handleCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
    barcode: string,
    code: string,
    price: string,
  ) => {
    const isChecked = event.target.checked;
    toggleCheckbox(id);
    setTags(prevTags => {
      if (isChecked) {
        return [
          ...prevTags,
          {
            barcode,
            code,
            price
          }
        ];
      } else {
        // Remove
        return prevTags.filter(tag => tag.barcode !== barcode);
      }
    });

  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  const exportData = async () => {
    startLoading();
    try {
      window.open('https://apioticamundial.clinicadeolhos.shop/lens-report', '_blank');
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const handleSetPopMenuList = (filterType: string, value: string | number) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));

    // Adicione código para marcar o cabeçalho como tendo um filtro ativo
    setHeaderTable(prevHeaders =>
      prevHeaders.map(header =>
        header.api === filterType
          ? { ...header, activeFilter: value ? true : false }
          : header
      )
    );
  };

  return (
    <S.Container>
      <TitleMenu
        filterSearch={handleSearchChange}
        title="Registro de Lentes"
        subtitle="Gerencie as lentes do sistema"
        placeholderSearch="Nome da Lente"
        listPopMenu={titleListPopMenu}
        fetchData={fetchData}
        listPopButton={titlePopButtton}
        exportButton={exportData}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="lens"
                  urlFilter={filters}
                  fetchData={fetchData}
                  nameDeleteAll='lens-delete-multiple'
                  handleDeleteResponse={handleDeleteResponse}
                  isTag={true}
                  itemsTag={tags}
                />
              )}
            </S.ContentButton>
            <S.Table>
              <S.THead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {
                    headerTable.map((header, index) => (
                      <th key={index}>
                        {
                          header.filter ?
                            (
                              <FilterTable
                                name={header.name}
                                data={header.data || []}
                                setPopMenuList={(value) =>
                                  handleSetPopMenuList(header.api || '', value)
                                }
                                filterActive={!!header.activeFilter}
                              />
                            ) :
                            header.name
                        }
                      </th>
                    ))
                  }
                </tr>
              </S.THead>

              <S.TBody>
                {data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={(e) => handleCheckChange(
                            e,
                            val.id,
                            val.barcode,
                            val.name_lens,
                            val.price
                          )}
                          type="checkbox"
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>{index + 1 || "-"}</td>
                      <td>
                        <NavLink
                          to='/estoqueDeLente'
                          state={{ id: val.id }}
                          style={{ color: "black", textDecoration: "none" }}
                          key={index + 1}>
                          <S.ButtonNav>
                            {val.name_lens || "-"}
                          </S.ButtonNav>
                        </NavLink>
                      </td>
                      <td>{val.indices?.index || "-"}</td>
                      <td>{val.type_lens?.type_lens || "-"}</td>
                      <td>{val.treatment?.treatment || "-"}</td>
                      <td>
                        {val.sensitivity?.sensitivity || "-"} (
                        {val.sensitivity?.percentage || "-"}%)
                      </td>
                      <td>
                        {val.spherical_start || "-"}/
                        {val.spherical_end || "-"}
                      </td>
                      <td>
                        {val.cylindrical_start || '-'}/
                        {val.cylindrical_end || '-'}
                      </td>
                      <td>
                        {val.addition_start || '-'}/
                        {val.addition_end || '-'}
                      </td>

                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}
      {
        isOpenModal("update") &&
        <Update
          isOpenModalLens={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          refreshData={fetchData}
        />
      }
      {
        isOpenModal("details") &&
        <Details
          isOpenModalDetails={isOpenModal("details")}
          setModalClose={() => toggleModalVisibility("details")}
          selectedUrlId={openModalOptId}
        />
      }

      <Delete
        updateList={fetchData}
        endpoint="lens"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
